export default __webpack_public_path__ + "static/media/simeon.23406975.jpg";